// extracted by css-extract-rspack-plugin
export default {"triggerButton":"triggerButton-rMGsn6"};